// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-layout {
  width: 100%;
  min-height: calc(100dvh - var(--headerHeight));
  padding: calc(var(--headerHeight) + 2.375rem) 2.375rem 0;
}
.main-layout.main-layout-dull {
  background-color: var(--cultured-1000);
  padding: 0 2.375rem 0;
}
@media screen and (max-width: 991.98px) {
  .main-layout {
    padding: calc(var(--headerHeight) + 1.25rem) 1.25rem 0;
  }
  .main-layout.main-layout-dull {
    padding: 0 1.25rem 0;
  }
}
@media screen and (max-width: 767.98px) {
  .main-layout {
    padding: calc(var(--headerHeight) + 1.25rem) 1rem 0;
  }
  .main-layout.main-layout-dull {
    padding: 0 1rem 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MainLayout/MainLayoutStyle.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,8CAAA;EACA,wDAAA;AACF;AACE;EACE,sCAAA;EACA,qBAAA;AACJ;AAEE;EAVF;IAWI,sDAAA;EACF;EACE;IACE,oBAAA;EACJ;AACF;AAEE;EAlBF;IAmBI,mDAAA;EACF;EACE;IACE,iBAAA;EACJ;AACF","sourcesContent":[".main-layout {\n  width: 100%;\n  min-height: calc(100dvh - var(--headerHeight));\n  padding: calc(var(--headerHeight) + 2.375rem) 2.375rem 0;\n\n  &.main-layout-dull {\n    background-color: var(--cultured-1000);\n    padding: 0 2.375rem 0;\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: calc(var(--headerHeight) + 1.25rem) 1.25rem 0;\n\n    &.main-layout-dull {\n      padding: 0 1.25rem 0;\n    }\n  }\n \n  @media screen and (max-width: 767.98px) {\n    padding: calc(var(--headerHeight) + 1.25rem) 1rem 0;\n\n    &.main-layout-dull {\n      padding: 0 1rem 0;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
